"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSource = exports.getSources = exports.getSourceById = exports.deleteSource = exports.defaultSourceData = exports.createSource = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultSourceData = exports.defaultSourceData = {
  id: 0,
  enabled: true,
  name: ''
};
const getSources = params => (0, _request.default)({
  url: '/sources',
  method: 'get',
  params
});
exports.getSources = getSources;
const getSourceById = id => (0, _request.default)({
  url: `/sources/${id}`,
  method: 'get'
});
exports.getSourceById = getSourceById;
const updateSource = (id, data) => (0, _request.default)({
  url: `/sources/${id}`,
  method: 'patch',
  data
});
exports.updateSource = updateSource;
const deleteSource = id => (0, _request.default)({
  url: `/sources/${id}`,
  method: 'delete'
});
exports.deleteSource = deleteSource;
const createSource = data => (0, _request.default)({
  url: '/sources/',
  method: 'post',
  data
});
exports.createSource = createSource;